<template>
  <li
    :class="['sortable-item', task.done ? 'sortable-item-done' : 'sortable-item-not-done']"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut">
    <template v-if="!isDeleting && task">
      <span v-handle class="handle"></span>
      <span class="sortable-item-duration sortable-item-duration--right">
        <duration-quick-settings v-model="task.duration" @save="onQuickSetDurationTask" />
        + {{aggregated_checklist_durations}} Min.
      </span>
      <span :class="[isActive ? 'task-icons-active' : 'task-icons-inactive']">
        <font-awesome-icon icon="trash-alt" class="taskicon" @click.prevent="onDeleteTask" />
        <font-awesome-icon icon="times" class="taskicon" @click.prevent="onRemoveTaskFromSession" />
        <font-awesome-icon icon="wrench" class="taskicon" @click.prevent="onEditTask" />
      </span>
      <font-awesome-icon :icon="task.done ? 'check-square': 'square'" fal class="symbol" @click.stop="onCheckTask" />
      &nbsp;
      <EditableText @update="onSetTaskName($event)" :text="task.name" :id="taskId" :inline="true">
        <span
          slot-scope="props"
          class="task-heading"
          :style="{
            fontFamily: 'Avenir',
            fontSize:   '24px',
            lineHeight: '32px',
            color:      color
          }">
          {{props.text}}
        </span>
      </EditableText>
      <div class="sortable-item-checklist">
        <!-- Checklist: -->
        <ul>
          <li
            v-for="item in checklistItems"
            :key="'checklist-item-'+item.id"
            :class="['task-checklist-item', item.done ? 'task-checklist-item-done' : 'task-checklist-item-not-done']">
            <font-awesome-icon :icon="item.done ? 'check-square': 'square'" fal class="symbol" @click.stop="onCheckTaskItem(item.id, item.done)" />

            <!-- {{item.name}} -->

            <EditableText @update="onSetChecklistItemName(item.id, $event)" :text="item.name ? item.name : 'No text'" :id="item.id" :inline="true">
              <span class="task-heading" slot-scope="props">
                {{props.text}}
              </span>
            </EditableText>

            <font-awesome-icon icon="trash-alt" class="taskicon" @click.prevent="onRemoveChecklistItem(item.id)" />
            <span class="sortable-item-duration sortable-item-duration--right">
              <duration-quick-settings v-model="item.duration" @save="onQuickSetDurationChecklistItem( item.id, $event )" suffix="Min." />
            </span>
          </li>
          <li><el-button size="mini" plain type="primary" @click="onAddChecklistItem">Add checklist item</el-button></li>
        </ul>
        <!-- <pre>onlyExistsInsideSession: {{task.onlyExistsInsideSession}}</pre> -->
      </div>
    </template>
    <template v-else>
      Deleting...
    </template>
  </li>
</template>

<script>
import EditableText from "@/components/Elements/EditableText";
import DurationQuickSettings from '@/components/Elements/DurationQuickSettings'
import { ElementMixin, HandleDirective } from 'vue-slicksort';
import { mapActions } from 'vuex'

/* Actions

X this.goal_task_add_checklist_item({ goal_id, task_id, data });
X this.goal_task_rem_checklist_item({ goal_id, task_id, item_id });
X this.goal_task_update_checklist_item({ goal_id, task_id, item_id, data });
this.goal_task_move_checklist_items_batch({ goal_id, task_id, batch });

^ TODO !!!

X this.remove_task({ id: id, goal_id })
X this.update_task({ id: id, data, goal_id })
*/

export default {
  mixins: [ElementMixin],
  directives: { handle: HandleDirective },
  props: {
    taskId: {
      dafault: null
    },
    goalId: {
      dafault: null
    },
    color: {
      default: '#000000'
    }
  },
  data() {
    return {
      isDeleting: false,
      isActive: false
    }
  },
  computed: {
    // ...mapGetters("goal",[
    //   "get_task_by_goal_id_and_task_id",
    //   "checklist_items_by_goal_id_and_task_id"
    // ]),

    task() {
      if ( this.taskId && this.goalId ) {
        return this.get_task_by_goal_id_and_task_id( this.goalId, this.taskId );
      } else {
        return null;
      }
    },

    checklistItems() {
      if ( this.taskId && this.goalId ) {
        return this.checklist_items_by_goal_id_and_task_id( this.goalId, this.taskId );
      } else {
        return null;
      }
    },

    aggregated_checklist_durations() {
      return this.checklistItems.reduce((acc,item) => acc + item.duration, 0);
    }
  },
  methods: {
    ...mapActions("goal",[
      "goal_task_add_checklist_item",
      "goal_task_update_checklist_item",
      "goal_task_move_checklist_items_batch",
      "goal_task_rem_checklist_item",
      "remove_task",
      "update_task",
      "edit_task",
      "goal_set_task_done"
    ]),

    onMouseOver(event) {
      this.isActive = true;
    },

    onMouseOut(event) {
      this.isActive = false;
    },

    onAddChecklistItem() {
      this.goal_task_add_checklist_item({
        goal_id: this.goalId,
        task_id: this.taskId,
        data: {}
      });
    },

    onSetTaskName(newTaskName) {
      console.log("onSetTaskName", newTaskName);
      this.edit_task({
        id: this.taskId,
        name: newTaskName,
        goal_id: this.goalId,
      });
    },

    onSetChecklistItemName(itemId, newName) {
      console.log("onSetChecklistItemName", newName);
      this.goal_task_update_checklist_item({
        goal_id: this.goalId,
        task_id: this.taskId,
        item_id: itemId,
        data: { name: newName }
      });
    },

    onCheckTaskItem(itemId, oldState) {
      // TODO: Add points for finishing task
      console.log("onCheckTaskItem", itemId);
      this.goal_task_update_checklist_item({
        goal_id: this.goalId,
        task_id: this.taskId,
        item_id: itemId,
        data: { done: !oldState }
      });
    },

    onDeleteTask() {
      // TODO: maybe move to store
      this.isDeleting = true;
      this.remove_task({
        id: this.taskId,
        goal_id: this.goalId,
      }).then(() => {
        // TODO: also remove reference here
        console.log("Task was deleted, removing reference...");
        this.$emit('remove-task', this.taskId)
        // TODO: ... or the other way around?
      })
    },

    onRemoveTaskFromSession() {
      if ( this.task.onlyExistsInsideSession ) {
        // TODO: Maybe dont allow
        if ( !confirm('Deleting a task that only exist inside a sesion') ) {
          return
        }
      }
      this.$emit('remove-task', this.taskId)
    },

    onRemoveChecklistItem(item_id) {
      this.goal_task_rem_checklist_item({
        goal_id: this.goalId,
        task_id: this.taskId,
        item_id: item_id
      });
    },

    onEditTask() {
      // this.cloneTask();
      // this.taskModalOpen = true;
      throw new Error('NOT IMPLEMENTED')
    },

    onQuickSetDurationChecklistItem(itemId, value) {
      console.log("onQuickSetDurationChecklistItem", itemId, value);
      this.goal_task_update_checklist_item({
        goal_id: this.goalId,
        task_id: this.taskId,
        item_id: itemId,
        data: { duration: value }
      });
    },

    onQuickSetDurationTask(value) {
      console.log("onQuickSetDurationTask", value);
      this.update_task({
        goal_id: this.goalId,
        id: this.taskId,
        data: { duration: value }
      });
    },

    onCheckTask() {
      // TODO: Add points for finishing task
      console.log("onCheckTask");
      this.goal_set_task_done({
        goal_id:    this.goalId,
        task_id:    this.taskId,
        task_done: !this.task.done
      });

      /* If we want to create an log event:
       if ( !this.task.done ) {
        this.activity_create_log({
          taskId:    this.taskId,
          goalId:    this.goalId,
          member_id:  this.memberId,
        });
      } */
    },
  },
  components: {
    EditableText,
    DurationQuickSettings
  }
}
</script>

<style>
body > .sortable-item {
  z-index: 9999;
}

.handle {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M0 7.5v5h50v-5H0zm0 15v5h50v-5H0zm0 15v5h50v-5H0z" color="%23000"/></svg>');
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.25;
  margin-right: 20px;
  cursor: row-resize;
}
.sortable-item .input-group {
  margin-bottom: 0;
}
.sortable-item {
  /* display: flex; */
  display: block;
  align-items: center;
  width: 100%;
  padding: 10px;
  background-color: #fff;
  border-bottom: 1px solid #efefef;
  box-sizing: border-box;
  user-select: none;
  color: #333;
  font-weight: 400;
  /* filter: drop-shadow(0 2px 4px rgba(0,0,0,0.25)); */
  margin-top: 5px;
  position: relative;
}
.sortable-item-duration--right {
  float: right;
  font-style: italic;
}
.task-checklist-item {
}
.sortable-item .task-icons-active {
  display: inline;
  cursor: pointer;
  margin-right: 100px;
}
.sortable-item .task-icons-inactive {
  display: none;
}
.sortable-item .taskicon {
  float: right;
  color: #555;
  margin: 2px;
  cursor: pointer;
  margin-left: 0.5em;
  margin-right: 0.25em;
  height: 23px;
}
.sortable-item .taskicon:hover {
  color: red;
}
.sortable-item-checklist {
  margin-top: 0.5em;
}
.sortable-item-checklist li {
  line-height: 32px;
  margin-left: 2em;
}
.task-checklist-item-done,
.sortable-item-done {
  opacity: 0.5;
}
</style>
